<div class="d-flex flex-column">
    <div class="d-flex sub-block-header">
        {{ subBlockHeader }}
    </div>
    <div class="d-flex block-content flex-column">
        <ng-content></ng-content>
    </div>
</div>
